/* ONE declaration of the space between the FORM and the record's readings
   (#2349 §C).
 *
 * Each reading used to carry its own `margin-top` — `OrganizationRegistry`'s
 * `.wrap` had `--sp-5`, the two KB panels had none — so the distance between the
 * form and what follows it was a per-file decision. That is #2283's own
 * complaint one surface further in, and it is why those panels are
 * `PageSection`s now: the space BETWEEN two readings is `.section + .section`'s,
 * and the only thing left for a host to own is the space before the first.
 */
.readings { margin-top: var(--sp-5); }

/* ── IN THE PAGE'S DETAILS CARD the readings are the card's last section ─────
   (#2406, leading design). The card no longer pads itself — its form sections
   do — so the readings take the same inset and the same joint as a form
   section instead of a margin under the form. */
[data-presentation='page'] .readings {
  margin-top: 0; padding: var(--sp-4-5) var(--sp-5);
  border-top: 1px solid var(--hair); box-shadow: 0 -1px 0 var(--rim);
}
